import React, { Component, Fragment } from 'react';
import classnames from 'classnames';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import combineStyles from '../../utils/combineStyles';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import ShipmentReference from '../../components/shipment/Reference';
import { withApollo } from 'react-apollo';
import { AppContext } from '../../AppProvider';
import PropTypes from 'prop-types';
import { all as customFieldQuery } from '../../graphQL/queries/customFields';
import _get from 'lodash/get';
export class References extends Component {
  static propTypes = {
    references: PropTypes.array.isRequired
  };
  state = { allReferenceFields: {} };
  async componentDidMount() {
    const { client: ApolloClient } = this.props;
    const { currentOrgId } = this.context.globalProps;

    try {
      const {
        data: {
          customField: { all }
        }
      } = await ApolloClient.query({
        query: customFieldQuery,
        variables: { orgId: currentOrgId, includeExpired: true }
      });
      const allReferenceFields = {};
      all.forEach(field => {
        allReferenceFields[field.stringId] = field;
      });
      this.setState({ allReferenceFields });
    } catch (error) {
      this.setState({
        error
      });
    }
  }

  render() {
    const { t, classes, references } = this.props;
    const { allReferenceFields } = this.state;

    return (
      <Fragment>
        <div
          className={classnames(
            classes.titleRootWrapper,
            classes.noMarginBottom
          )}
        >
          <h2 className={classes.headline7}>{t('References')}</h2>
        </div>
        <div className={classnames(classes.emptyWrapper, classes.flexWrap)}>
          {references.map((reference, index) => {
            return (
              <ShipmentReference
                key={index}
                type={_get(
                  allReferenceFields,
                  `${reference.stringId}.label`,
                  ''
                )}
                details={reference.values.join(', ')}
              />
            );
          })}
        </div>
      </Fragment>
    );
  }
}
References.contextType = AppContext;
const ReferencesTranslated = withNamespaces()(withApollo(References));

export default withStyles(
  combineStyles(TypographyStyles, LayoutStyles, SpacingStyles)
)(ReferencesTranslated);
